export function newClientId() {
  return Math.round(Math.random() * -1000000);
}

export function isClientId(key: number | undefined) {
  return key && key <= 0;
}
